export default function WidgetDescription(): JSX.Element {
  return (
    <div
      className='visually-hidden'
      data-nosnippet
      id='forethought-widget-description'
    >
      The Forethought Solve widget is a virtual assistant. You have the ability
      to select relevant choices or enter text in the provided fields with
      information related to your needs. The assistant will provide information
      to help fulfill your requirements.
    </div>
  );
}
